const actions = {
  setConfig: 'SET_CONFIG',
  webcoreLoading: 'WEBCORE_LOADING',
};

export function startFunctionalSkillSession(sessionID) {
  return (dispatch) => {
    const webcoreConfig = {};

    const relativePath = '/play_game?functional_session_id=' + sessionID;

    webcoreConfig.relative_path = relativePath;

    dispatch({
      type: actions.setConfig,
      webcore_config: webcoreConfig,
      render_webcore: true,
    });
  };
}

export function unloadWebcore() {
  return {
    type: actions.setConfig,
    webcore_config: {},
    render_webcore: false,
    load_webcore: true,
  };
}

export function webcoreLoading() {
  return {
    type: actions.webcoreLoading,
    load_webcore: false,
  };
}

export function loadWebcore(relativePath) {
  const webcoreConfig = {};
  webcoreConfig.relative_path = relativePath;

  return {
    type: actions.setConfig,
    webcore_config: webcoreConfig,
    render_webcore: true,
    load_webcore: true,
  };
}

const INITIAL_STATE = {
  webcore_config: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.setConfig:
      return {
        ...state,
        webcore_config: action.webcore_config,
        render_webcore: action.render_webcore,
        load_webcore: action.load_webcore,
      };
    case actions.webcoreLoading:
      return {
        ...state,
        load_webcore: action.load_webcore,
      };
    default:
      return { ...state };
  }
}
